import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from 'src/app/_service/leads.service';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-list-pincode-machine-master',
  templateUrl: './list-pincode-machine-master.component.html',
  styleUrls: ['./list-pincode-machine-master.component.css']
})
export class ListPincodeMachineMasterComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; zoneMachineList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles = []; circles_copy = []; circle = '';
  zones = []; zone = ''; circle_zone: boolean = true; allscanmachine: any; allscanmachine_copy: any;
  machine = ''; 
  constructor(private sharedapi: SharedService, public miscapi: MiscService, public leadapi: LeadsService) { }

  ngOnInit(): void {
    this.getcircle();
    this.getScanMachine();
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getCircleZone(circle_id) {
    this.zone = '';
    let qString = 'circle=' + circle_id;
    await this.miscapi.getCircle_zone(qString).subscribe((data: any) => {
      if (data.status) {
        this.zones = data.data;
        this.circle_zone = false;
      } else {
        this.zones = [];
        this.circle_zone = false;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }
  async getScanMachine() {
    await this.miscapi.getallScanMachine().subscribe((data: any) => {
      if (data.status) {
        this.allscanmachine = data.data;
        this.allscanmachine_copy = this.allscanmachine;
      } else {
        this.allscanmachine = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'machine') {
      this.allscanmachine = this.sharedapi.searchData(searchtText, this.allscanmachine_copy, "name");
    }
  }

  setSearchValue(type) {
     if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'machine') {
      $("#machineSearch").val('');
      $("#machineSearch").focus();
      this.allscanmachine = this.allscanmachine_copy;
    }
  }

  ngAfterViewInit() {
    this.loadZoneMachineList(0, this.perpage);
  }

  async loadZoneMachineList(pageIndex, perpage) {
    this.zoneMachineList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'circle=' + this.circle + '&zone=' + this.zone + '&machine=' + this.machine;
    this.loading = true; this.loaded = false;
    await this.miscapi.getZoneMachineList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.zoneMachineList = data.data;
      } else {
        this.zoneMachineList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadZoneMachineList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadZoneMachineList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.circle = ''; this.zone = ''; this.machine = '';
    this.loadZoneMachineList(0, 25); this.zones = [];
  }
  //=====Export List=====//
  exportZoneMacList() {
    if (this.zoneMachineList.length > 0) {
      let data = [];
      let titles = ['Circle Name', 'Zone Name', 'Machine'];

      data.push(titles);

      for (let key in this.zoneMachineList) {
        let extData = [this.zoneMachineList[key].circle_name, this.zoneMachineList[key].zoneName, this.zoneMachineList[key].machineName];
        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'zoneMachinelist' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Zone Machine Data found!');
    }
  }




}
